import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { splitArray } from './utils';

const styles = theme => ({
    root: {
        maxWidth: '1030px',
        margin: '0 auto',
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    title: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
    },
    row: {
        display: 'flex',
        overflow: 'hidden',
        '&.left': {
            justifyContent: 'flex-start',
        },
        '&.center': {
            justifyContent: 'center',
        },
        '&.right': {
            justifyContent: 'flex-end',
        },
    },
    cell: {
        display: 'flex',
    },
});

function Dashboard({
    title,
    width,
    columns,
    align,
    classes,
    className,
    subtitle,
    children,
}) {
    const rows = splitArray(React.Children.toArray(children), {
        columns,
        fill: false,
    });
    const wrapCell = (child, i) => (
        <div
            key={i}
            className={classes.cell}
            style={{ width: `${width || 100 / columns}%` }}
        >
            {child}
        </div>
    );
    const wrapRow = (row, i) => (
        <div key={i} className={classNames(classes.row, align)}>
            {row.map(wrapCell)}
        </div>
    );
    return (
        <div className={classNames(classes.root, className)}>
            {title && (
                <Typography variant="h6" className={classes.title}>
                    {title}
                </Typography>
            )}
            {subtitle && (
                <Typography className={classes.title}>{subtitle}</Typography>
            )}
            {rows.map(wrapRow)}
        </div>
    );
}

Dashboard.propTypes = {
    title: PropTypes.string,
    columns: PropTypes.number,
    align: PropTypes.oneOf(['left', 'center', 'right']),
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

Dashboard.defaultProps = {
    title: '',
    columns: 2,
    align: 'left',
};

export default withStyles(styles)(Dashboard);
